<template lang="pug">
  header.topTitle
    router-link.logo(:to="{name: 'Home'}")
      img(:src="hamisLogo")
    nav.linkBar
      .modal(@click="navBarShow(false)" v-show="navBarIsShow")
      button.clickBtn(@click="toggleNavBarShow")
        // :class="{trans : navBarIsShow}")
      ul.navBar(v-show="navBarIsShow || windowWidth > 500")
        button.closeBtn(@click="navBarShow(false)")
        li.navItem(v-for="item in links" :class="[hasChildren(item), iconSetting(item), isActive(item)]"
                  @click="(item.link && gotoLink(item.link)) || toggleChildrenVisible(item)"
                  @mouseover="windowWidth > 500 && setChildrenVisible(item)"
                  @mouseout="windowWidth > 500 && setChildrenUnvisible(item)")
          span(:class="{grow: item.childrenVisible}") {{ item.label }}
          ul.linkItemBar(v-if="item.children && item.children.length > 0"
              v-show="item.childrenVisible && item.label === '产品'")
            li(v-for="link in item.children")
              router-link.linkItem(:to="{name: link.link}"
                :class="[linkIcon(link.link), isActive(link)]") {{ link.name }}
              
          ul.solutionLinkItemBar(v-if="item.children && item.children.length > 0"
              v-show="item.childrenVisible && item.label === '解决方案'")
            .solutionLinkItem(v-for="solutions in item.children")
              .linkTitle(class="linkItem") {{ solutions.label }}
              li(v-for="link in solutions.children")
                router-link.linkItem(:to="{name: link.link}"
                  :class="[linkIcon(link.link), isActive(link)]")  {{ link.name }}
  
    button.experienceLink(class="linkBtn" @click="gotoExperience")
      span 申请体验
    //.tenSpace(style="width: 10px; flex-shrink: 0;")
    //button.login(class="linkBtn" @click="gotoLogin")
      span 登录
</template>

<script>
  import hamisLogo from '@/assets/images/HAMISlogo1.png';
  
  export default {
    name: "topTitle",
    props: {},
    data() {
      return {
        hamisLogo,
        nowPage: 1,
        links: [
          {label: '首页', link: 'Home'},
          {
            label: '产品',
            children: [
              {name: 'Data OPS', link: 'BigDataOps'},
              {name: 'AI OPS', link: 'AIOps'},
              {name: 'IoT OPS', link: 'IotOps'},
              {name: 'Rcmd OPS', link: 'RecommendationOps'},
              {name: 'MKT OPS', link: 'MarketingOps'},
            ],
            childrenVisible: false
          },
          {
            label: '解决方案', children: [
              {label: '通用解决方案', children: [
                  {name: '人脸识别', link: 'FaceSaaS'},
                  {name: '精准营销', link: 'PrecisionMarketing'},
                  {name: '个性化推荐', link: 'Recommendation'},]},
              {label: '行业解决方案', children: [
                  {name: '数字城市', link: 'DigitalCity'},
                  {name: '数字教育', link: 'DigitalEducation'},]},
            ],
            childrenVisible: false,
          },
          {label: '价格', link: 'Price'},
          //{label: '使用指南'},
          {label: '关于我们', link: 'AboutUs'},
        ],
        nowVisible: null,
        navBarIsShow: false,
        windowWidth: 0,
      };
    },
    watch: {
      $route(val, oldVal) {
        this.navBarIsShow = false;
        window.scrollTo(0, 0)
      }
    },
    computed: {
    },
    methods: {
      isActive(item) {
        if (item.link) {
          return {isNowRoute: this.$route.name === item.link};
        } else if (item.children) {
          for (let i of item.children) {
            if (this.$route.name === i.link ) {
              return "isNowRoute";
            }
          }
        }
        return {isNowRoute: item.link ? this.$route.name === item.link : false};
      },
      iconSetting(item) {
        const iconSetting = {
          '首页': 'home',
          '产品': 'product',
          '解决方案': 'solution',
          '价格': 'price',
          '关于我们': 'about',
        };
        return iconSetting[item.label];
      },
      hasChildren(item) {
        return {superNavItem: item.children && item.children.length > 0};
      },
      gotoExperience() {
        this.$router.push({name: 'GuestForm'})
        window.scrollTo(0, 0)
      },
      gotoLogin() {
        this.$router.push({name: 'LoginForm'})
        window.scrollTo(0, 0)
      },
      gotoLink(val) {
        this.$router.push({name: val});
        window.scrollTo(0, 0);
        this.navBarIsShow = false;
      },
      setChildrenVisible(item) {
        if (this.nowVisible) {
          this.nowVisible.childrenVisible = false;
        }
        item.childrenVisible = true;
        this.nowVisible = item;
      },
      setChildrenUnvisible(item) {
        item.childrenVisible = false;
      },
      toggleChildrenVisible(item) {
        item.childrenVisible = !item.childrenVisible;
        if (this.nowVisible && this.nowVisible !== item) {
          this.nowVisible.childrenVisible = false;
        }
        this.nowVisible = item;
      },
      linkIcon(name) {
        const classList = {
          "BigDataOps": 'dataOpsIcon',
          "AIOps": 'aiOpsIcon',
          "IotOps": 'iotOpsIcon',
          "MarketingOps": 'marketingOpsIcon',
          "RecommendationOps": 'rcmdOpsIcon',
          "FaceSaaS": 'faseSaasIcon',
          "PrecisionMarketing": 'MarketingIcon',
          "Recommendation": 'rcmdIcon',
          "DigitalCity": 'dcIcon',
          "DigitalEducation": 'deicon',
        }
        return classList[name];
      },
      linkItemBar(label) {
        const linkBar = {
          '产品': '',
          '解决方案': 'solutionLinkItemBar',
        };
        return linkBar[label];
      },
      navBarShow(val) {
        this.navBarIsShow = val;
      },
      toggleNavBarShow() {
        this.navBarIsShow = !this.navBarIsShow;
      },
    },
    created() {
      this.windowWidth = window.innerWidth
    },
    mounted() {
      window.addEventListener('resize', () => this.windowWidth = window.innerWidth);
    },
  };
</script>

<style scoped lang="stylus">
  @import "../views/index.styl"
  a {
    color inherit
  }
  li {
    display flex
  }
  .topTitle {
    position absolute
    top 10px
    left 0
    z-index 2
    width 100%
    background-color transparent
    display flex
    justify-content flex-start
    align-items center
    padding-right 80px
    box-sizing border-box
    .logo {
      margin-right auto
      margin-left 80px
    }
    
    .linkBar {
      display block
      margin-right 50px
      width max-content
      //HStack(center)
      .modal {
        display none
      }
      .clickBtn {
        display none
        flex-shrink 0
        width 28px
        height 3px
        background-color white
        border none
        border-radius .5 * @height
        outline none
        position relative
        margin 16px 10px
        transition all .3s linear
        &::before, &::after {
          content ""
          width 100%
          height 100%
          position absolute
          border-radius 1.5px
          left 0
          background-color white
          transition all .3s linear
        }
        &::before {
          top -8px
        }
        &::after {
          bottom -8px
        }
      }
      .trans {
        transform rotate(90deg) scale(.5)
        &::before {
          transform translate(-7px, 2px) rotate(-45deg) scaleX(.5)
        }
        &::after {
          transform translate(-7px, -2px) rotate(45deg) scaleX(.5)
        }
      }
      .closeBtn {
        display none
        position absolute
        right 0
        top 0
        height 38px
        width 38px
        border none
        outline none
        background-color transparent
        &::before, &::after {
          content ""
          position absolute
          width 50%
          height 0
          top calc(50% - 1px)
          right calc(50% - 50% / 2)
          border 1px solid #999
        }
        &::before {
          transform rotate(45deg)
        }
        &::after {
          transform rotate(-45deg)
        }
      }
      .navBar {
        display flex
        justify-content flex-start
        align-items center
      }
      .navItem {
        width fit-content
        max-width 100%
        color rgba(255, 255, 255, .5)
        padding 20px
        font-size (16 / 14)rem
        cursor pointer
        FontSetting("思源黑体 CN Regular")
        position relative
        
        &:hover {
          color #fff
        }
        > span {
          white-space nowrap
        }
      }
    }
    @media (max-width 1050px) {
      padding-right 20px
      .logo {
        margin-left 20px
      }
    }
    @media (max-width 922px) {
      .linkBar {
        .navItem {
          padding 20px 10px
          .solutionLinkItemBar, .linkItemBar {
            left 16px
          }
        }
      }
    }
  }
  
  .solutionLinkItemBar, .linkItemBar {
    position absolute
    top 60px
    left -8px
    width max-content
    background-color rgba(#161616, .7)
    &::before {
      content ""
      position absolute
      top -6px
      left 40px
      border-left 4px solid transparent
      border-right 4px solid transparent
      border-bottom 6px solid rgba(#161616, .7)
    }
  }
  
  .linkItemBar {
    &::before {
      left 40px
    }
  }
  .solutionLinkItemBar {
    HStack()
    width max-content
    width 396px
    &::before {
      left 61px
    }
  }
  
  .solutionLinkItem {
    VStack()
    width max-content
    .linkTitle {
      border-bottom 1px solid rgba(#fff, .1)
      /*padding-left 35px*/
      padding 18px 33px 18px 35px
      width 100%
      min-width 110px
      box-sizing border-box
      cursor default
      &::before {
        content none
      }
      &:hover {
        background-color transparent
        color #aaa
      }
    }
  }
  .linkItem {
    width 110px
    padding 14px 33px 14px 55px
    color #aaaaaa
    position relative
    &::before {
      position absolute
      height 20px
      width 20px
      top calc(50% - 10px)
      left 28px
      content ""
      mask-size 20px
      background-color #aaaaaa
    }
  
    &:hover {
      color white
      background-color rgba(#000, .5)
      &::before {
        background-color white
      }
    }
  }

  .isNowRoute {
    color #fff
    span {
      color #fff
    }
  }
  
  .dataOpsIcon::before {
    mask url("../assets/images/大数据平台.png") no-repeat center
    mask-size 20px
  }
  .aiOpsIcon::before {
    mask url("../assets/images/AI平台.png") no-repeat center
    mask-size 20px
  }
  .iotOpsIcon::before {
    mask url("../assets/images/物联网平台.png") no-repeat center
    mask-size 20px
  }
  .marketingOpsIcon::before {
    mask url("../assets/images/智能推荐平台.png") no-repeat center
    mask-size 20px
  }
  .rcmdOpsIcon::before {
    mask url("../assets/images/精准营销平台.png") no-repeat center
    mask-size 20px
  }
  .faseSaasIcon::before {
    mask url("../assets/images/人脸识别icon.png") no-repeat center
    mask-size 20px
  }
  .MarketingIcon::before {
    mask url("../assets/images/精准营销.png") no-repeat center
    mask-size 20px
  }
  .rcmdIcon::before {
    mask url("../assets/images/个性化推荐.png") no-repeat center
    mask-size 20px
  }
  .dcIcon::before {
    mask url("../assets/images/数字城市icon.png") no-repeat center
    mask-size 20px
  }
  .deicon::before {
    mask url("../assets/images/数字教育icon.png") no-repeat center
  }
  .solutionLinkItemBar {
  
  }

  @media (max-width ipadProScreenWidth min-width screenWidth) {
    .topTitle {
      padding-right 20px
      top 0
      .logo {
        margin-left 30px
      }
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .topTitle {
      width calc(100vw - 20px)
      
    }
    .linkItem {
      &::before {
        background-color transparent
      }
      &:hover {
        &::before {
          background-color transparent
        }
      }
    }
    .dataOpsIcon::before {
      background url("../assets/images/ie/大数据平台.png") no-repeat center
      background-size 20px
    }
    .aiOpsIcon::before {
      background url("../assets/images/ie/AI平台.png") no-repeat center
      background-size 20px
    }
    .iotOpsIcon::before {
      background url("../assets/images/ie/物联网云平台.png") no-repeat center
      background-size 20px
    }
    .marketingOpsIcon::before {
      background url("../assets/images/ie/智能推荐平台.png") no-repeat center
      background-size 20px
    }
    .rcmdOpsIcon::before {
      background url("../assets/images/ie/精准营销平台.png") no-repeat center
      background-size 20px
    }
    .faseSaasIcon::before {
      background url("../assets/images/ie/人脸识别.png") no-repeat center
      background-size 20px
    }
    .MarketingIcon::before {
      background url("../assets/images/ie/精准营销.png") no-repeat center
      background-size 20px
    }
    .rcmdIcon::before {
      background url("../assets/images/ie/个性化推荐.png") no-repeat center
      background-size 20px
    }
    .dcIcon::before {
      background url("../assets/images/ie/数字城市.png") no-repeat center
      background-size 20px
    }
    .deicon::before {
      background url("../assets/images/ie/数字教育.png") no-repeat center
    }
  }
  @media (max-width screenWidth) {
    .topTitle {
      top 0
      position fixed
      background-color #202020
      width max-content
      padding 0
      z-index 1000
      .logo {
        position absolute
        top 10px
        width 193px
        margin-left 10px
        z-index 2
        > img {
          height 20px
        }
      }
      .linkBar {
        VStack()
        margin-right 0
        width 100vw
        .modal {
          display block
          height 100vh
          width 100%
          background-color rgba(#000, .5)
          position absolute
          z-index 1
        }
        .clickBtn {
          display block
          align-self flex-end
          z-index 3
        }
        .closeBtn {
          display none
        }
        .superNavItem {
          span {
            width 100%
            display inline-block
            position relative
            &::before {
              content ""
              position absolute
              height 30px
              width 30px
              top calc(50% - 15px)
              right 30px
              mask url("../assets/images/下箭头.png") no-repeat center
              mask-size 18px
              background-color #202020
              transition all .3s
            }
          }
        }
        .grow {
          width 100%
          &::before {
            transform rotate(180deg)
          }
        }
        .navBar {
          width calc(100vw - 20px)
          background-color white
          padding-left 20px
          height max-content
          flex-direction column
          align-items flex-start
          z-index 3
          &::after {
            content ""
            height 30px
          }
          .navItem {
            color #202020
            padding 20px 6px
            position relative
            border-bottom 1px solid #e4e4e4
            width calc(100% - 32px)
            flex-direction column
            > span {
              color #202020
              padding-left 30px
            }
            &::before {
              content ""
              position absolute
              top 24px
              left 0
              width 20px
              height 20px
              mask-size 20px
              background #202020
            }
          }
          .isNowRoute {
            color #269bff
            span {
              color #269bff
            }
            &::before {
              background #269bff
            }
          }
          .home::before {
            mask url("../assets/images/homeIcon.png") no-repeat center
            mask-size 20px
          }
          .product::before {
            mask url("../assets/images/productIcon.png") no-repeat center
            mask-size 20px
          }
          .solution::before {
            mask url("../assets/images/solutionIcon.png") no-repeat center
            mask-size 20px
          }
          .price::before {
            mask url("../assets/images/priceIcon.png") no-repeat center
            mask-size 20px
          }
          .about::before {
            mask url("../assets/images/aboutIcon.png") no-repeat center
            mask-size 20px
          }
          .solutionLinkItemBar, .linkItemBar {
            position static
            color rgba(#000, .5)
            background-color transparent
            margin-left 28px
            max-width 300px
            HStack()
            flex-wrap wrap
            padding-top 8px
            &::before {
              content none
            }
            .linkItem {
              padding 10px
              padding-left 30px
              color #202020
              &::before {
                left 2px
                background #202020
              }
            }
            .isNowRoute {
              color #269bff
              span {
                color #269bff
              }
              &::before {
                background #269bff
              }
            }
            .linkTitle {
              display none
            }
          }
        }
      }
      .experienceLink {
        display none
      }
    }
  }
</style>
